<template>
  <div class="mt-5">
    <file-findings-table
      :file-findings="fileFindings"
      :file-findings-loading="fileFindingsLoading"
      :file-findings-total="fileFindingsTotal"
      @load-more="loadMoreItems"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { useTicketStore } from "@/_store/tickets/ticket.module";
import { storeToRefs } from "pinia";
import FileFindingsTable from "../base-components/FileFindingsTable.vue";

export default defineComponent({
  components: {
    FileFindingsTable,
  },
  setup() {
    const ticketStore = useTicketStore();
    const { fileFindings, fileFindingsLoading, fileFindingsTotal } = storeToRefs(ticketStore);
    const page = ref(0);

    const getItems = async (virtualScroll = false) => {
      await ticketStore.getFileFindings({
        page: page.value,
        virtualScroll,
      });
    };

    onMounted(async () => {
      await getItems();
    });

    const loadMoreItems = () => {
      page.value += 1;
      getItems(true);
    };

    return {
      page,
      fileFindings,
      fileFindingsLoading,
      fileFindingsTotal,
      loadMoreItems,
    };
  },
});
</script>
